import React from 'react';
import {Link} from '@material-ui/core';
import {useGetMessages} from '../../hooks';

interface Props {
    code: string;
    onClick?: (e?) => void;
}

const DialogLink: React.FC<Props> = ({code, onClick}) => {
    const messages = useGetMessages({text: code});
    return (
        <Link component="span" onClick={onClick} underline="hover" color="primary">
            {messages.text}
        </Link>
    );
};

export default DialogLink;
